import { render, staticRenderFns } from "./DebtorCustomers.vue?vue&type=template&id=997aafc8&scoped=true&"
import script from "./DebtorCustomers.vue?vue&type=script&lang=js&"
export * from "./DebtorCustomers.vue?vue&type=script&lang=js&"
import style0 from "./DebtorCustomers.vue?vue&type=style&index=0&id=997aafc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997aafc8",
  null
  
)

export default component.exports